module.exports = __webpack_public_path__ + "media/referral/referral-leaves-4c669184.svg";